import { GetStaticProps } from 'next'
import fs from 'fs'
import path from 'path'

import PageProject, { PageProjectProps } from '@/components/PageProject/PageProject'

export async function getStaticPaths() {
  const pagesDir = path.join(process.cwd(), 'src/data/pages')
  const filenames = fs.readdirSync(pagesDir).filter((file) => file.endsWith('.ts'))

  const paths = filenames.map((filename) => ({
    params: { project: filename.replace(/\.ts$/, '') }
  }))

  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps<PageProjectProps> = async ({ params }) => {
  if (!params || !params.project) {
    return { notFound: true }
  }

  // Dynamically import the page data
  const pageData = await import(`src/data/pages/${params.project}.ts`) // or '.ts' if you're sure

  return {
    props: {
      head: { title: pageData.default.name },
      content: pageData.default
    }
  }
}

export default PageProject
